"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Expression = void 0;
/**
 * Represents an abstract expression that defines an interface for evaluating expressions.
 * @template T The input type for the expression.
 * @template R The type of result produced by the expression.
 */
class Expression {
}
exports.Expression = Expression;
